import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, ShieldAlert } from 'lucide-react';
import { EmptyState } from '../components/ui/misc';

const HomeLink = () => (
  <Link
    to="/"
    className="inline-flex h-9 items-center rounded-lg bg-accent-solid px-3.5 text-sm font-medium text-on-accent hover:bg-accent-solid/90"
  >
    Back to search
  </Link>
);

export const NotFoundPage = () => (
  <EmptyState icon={Compass} title="Page not found" actions={<HomeLink />} className="py-24" headingLevel={1}>
    The page you were looking for doesn&apos;t exist or has moved.
  </EmptyState>
);

export const ForbiddenPage = () => (
  <EmptyState icon={ShieldAlert} title="You don't have access to this page" actions={<HomeLink />} className="py-24" headingLevel={1}>
    This area is for administrators. Ask an administrator if you need access.
  </EmptyState>
);
